import { parseAsStringEnum, useQueryState } from 'nuqs';
import { GetQuizsetRankingsPeriod } from '@/api/gen/_model/getQuizsetRankingsPeriod';
import { GetQuizsetRankingsSchoolType } from '@/api/gen/_model/getQuizsetRankingsSchoolType';
export const useSelectedFeaturedQuiz = () => {
  const [schoolType, setSchoolType] = useQueryState('schoolType', parseAsStringEnum<QuizsetRankingsSchoolType>(Object.values(QuizsetRankingsSchoolType)) // pass a list of allowed values
  .withDefault('ALL'));
  const [selectedPeriod, setSelectedPeriod] = useQueryState('period', parseAsStringEnum<GetQuizsetRankingsPeriod>(Object.values(GetQuizsetRankingsPeriod)) // pass a list of allowed values
  .withDefault('DAILY'));
  return {
    selectedSchoolType: schoolType,
    setSelectedSchoolType: setSchoolType,
    setSchoolType,
    selectedPeriod: selectedPeriod,
    setSelectedPeriod: setSelectedPeriod
  };
};
export const QuizsetRankingsSchoolType = {
  ...GetQuizsetRankingsSchoolType,
  ALL: 'ALL'
} as const;
export type QuizsetRankingsSchoolType = (typeof QuizsetRankingsSchoolType)[keyof typeof QuizsetRankingsSchoolType];